package horcrux.common.api.dtos

import horcrux.common.HorcruxRequestSimpleError
import horcrux.common.api.dtos.types.CollectionID
import horcrux.common.api.dtos.types.DocumentChunkURL
import horcrux.common.api.dtos.types.DocumentID
import horcrux.common.api.dtos.types.DocumentMetadata
import horcrux.common.api.dtos.types.DocumentName
import horcrux.common.api.dtos.types.UserID
import io.ktor.http.HttpStatusCode
import kotlinx.serialization.Serializable

@Serializable
data class GetDocumentResponse(val documentChunkURL: DocumentChunkURL) : HorcruxResponse

open class GetDocumentError(httpStatusCode: HttpStatusCode) : HorcruxRequestSimpleError(httpStatusCode)
data class NoDocumentParentsFoundError(val documentID: DocumentID, val userID: UserID) :
    GetDocumentError(HttpStatusCode.NotFound)

@Serializable
class PatchDocumentRequest(
    val documentID: DocumentID,
    val newDocumentName: DocumentName,
    val collectionID: CollectionID,
) : HorcruxValidatedRequest

@Serializable
data class PatchDocumentResponse(val documentMetadata: DocumentMetadata) : HorcruxResponse

@Serializable
class DeleteDocumentRequest(
    val documentID: DocumentID,
    val collectionID: CollectionID,
) : HorcruxValidatedRequest

@Serializable
class DeleteDocumentResponse : HorcruxResponse
